import { io } from 'socket.io-client';
import { API_ROOT } from 'lib/httpSetup';
import { showTwilioAdminPopup } from 'lib/notificationBus';

let socket = null;
let listenersBound = false;

const resolveSocketUrl = () => {
    if (!API_ROOT) return window.location.origin;

    if (/^https?:\/\//i.test(API_ROOT)) {
        try {
            return new URL(API_ROOT).origin;
        } catch {
            return window.location.origin;
        }
    }

    return window.location.origin;
};

const buildTwilioErrorMessage = (eventName, payload = {}) => {
    const retryAfter = Number(payload.retryAfterMs || payload.cooldownMs || 0);
    const retryText = retryAfter > 0 ? ` Retry in ${Math.ceil(retryAfter / 1000)}s.` : '';

    if (typeof payload.message === 'string' && payload.message.trim()) {
        return payload.message.trim();
    }

    if (eventName === 'twilio.voice.stt.rate_limited') {
        return `STT service is currently rate-limited.${retryText}`;
    }

    if (eventName === 'twilio.invite.delivery_failed') {
        return `Twilio invite delivery failed for ${payload.phoneNumber || 'a recipient'}.`;
    }

    if (eventName === 'twilio.invite.job_failed') {
        return 'Twilio bulk invite job failed.';
    }

    return 'Twilio/STT service error detected.';
};

const bindListeners = () => {
    if (!socket || listenersBound) return;
    listenersBound = true;

    const events = [
        'twilio.voice.stt.rate_limited',
        'twilio.voice.stt.error',
        'twilio.invite.delivery_failed',
        'twilio.invite.job_failed',
        'twilio.error',
    ];

    events.forEach((eventName) => {
        socket.on(eventName, (payload = {}) => {
            const message = buildTwilioErrorMessage(eventName, payload);
            const dedupeKey = [
                eventName,
                payload?.sessionId || '',
                payload?.callSid || '',
                payload?.phoneNumber || '',
                message,
            ].join('|');

            showTwilioAdminPopup(message, { dedupeKey });
        });
    });
};

export const startTwilioRealtimeNotifications = () => {
    if (socket) {
        if (!socket.connected) socket.connect();
        bindListeners();
        return;
    }

    socket = io(resolveSocketUrl(), {
        transports: ['websocket', 'polling'],
        withCredentials: false,
        autoConnect: true,
    });

    socket.on('connect_error', () => {
        showTwilioAdminPopup('Unable to connect to realtime Twilio monitor channel.');
    });

    bindListeners();
};

export const stopTwilioRealtimeNotifications = () => {
    if (!socket) return;
    socket.disconnect();
};
